module.exports = __webpack_public_path__ + "power_down.ec9af3ff.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/power_down.png
// module id = 488
// module chunks = 0